import { render, staticRenderFns } from "./SvgTitle.vue?vue&type=template&id=01e9c746&scoped=true"
import script from "./SvgTitle.vue?vue&type=script&lang=js"
export * from "./SvgTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9c746",
  null
  
)

export default component.exports